/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { TagVariant } from 'ui/designSystem/Tag/types'
import { BookClubCertification } from 'ui/svg/BookClubCertification'
import { CineClubCertification } from 'ui/svg/CineClubCertification'
import { ThumbUpFilled } from 'ui/svg/icons/ThumbUpFilled'
import { ProEditoCertification } from 'ui/svg/ProEditoCertification'
import { Star } from 'ui/svg/Star'

export const variantBackground = {
  [TagVariant.DEFAULT]: 'subtle',
  [TagVariant.SUCCESS]: 'success',
  [TagVariant.WARNING]: 'warning',
  [TagVariant.ERROR]: 'error',
  [TagVariant.NEW]: 'brandPrimary',
  [TagVariant.BOOKCLUB]: 'bookclub',
  [TagVariant.CINECLUB]: 'cineclub',
  [TagVariant.HEADLINE]: 'headline',
  [TagVariant.LIKE]: 'subtle',
  [TagVariant.PROEDITO]: 'proEdito',
}

export const variantIconColor = {
  [TagVariant.DEFAULT]: 'default',
  [TagVariant.SUCCESS]: 'success',
  [TagVariant.WARNING]: 'warning',
  [TagVariant.ERROR]: 'error',
  [TagVariant.BOOKCLUB]: 'bookclub',
  [TagVariant.CINECLUB]: 'cineclub',
  [TagVariant.HEADLINE]: 'headline',
  [TagVariant.LIKE]: 'brandPrimary',
  [TagVariant.PROEDITO]: 'proEdito',
}

export const variantLabelColor = {
  [TagVariant.NEW]: 'inverted',
}

export const variantIcons = {
  [TagVariant.BOOKCLUB]: BookClubCertification,
  [TagVariant.CINECLUB]: CineClubCertification,
  [TagVariant.HEADLINE]: Star,
  [TagVariant.LIKE]: ThumbUpFilled,
  [TagVariant.PROEDITO]: ProEditoCertification,
}
